import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { PopupAction } from '../../../common/popup/PopupAction'
import { selectLoading, selectSettings } from '../store/slice'
import { updateAlertSettings } from '../store/thunk'
import { Checkbox } from './../../../common/html/checkbox/index'

export const SettingItem = ({ settingKey, title, description }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectSettings(settingKey))
  const isLoadingUpdate = useSelector(selectLoading('updateSettings'))

  const [isShow, setIsShow] = useState(false)

  const handleOpen = () => {
    setIsShow(true)
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const dispatchUpdateSettings = (isCheck = false) => {
    dispatch(updateAlertSettings({ [settingKey]: isCheck }))
  }

  const handleChange = (isCheck) => {
    if (isLoadingUpdate) return

    if (isCheck) {
      dispatchUpdateSettings(isCheck)
    } else {
      handleOpen()
    }
  }

  const handleSubmit = () => {
    dispatchUpdateSettings(false)
    handleClose()
  }

  return (
    <>
      <Element className="my2">
        <Checkbox
          title={title}
          isI18n
          checked={checked}
          onChange={handleChange}
          isCheckOnClickText
          className="fw600"
        />
        <Element style={{ color: '#3A414B', marginTop: 3 }}>
          <Translate value={description} />
        </Element>
      </Element>
      <PopupAction
        isShow={isShow}
        title="alertSetting.DISABLE_EMAILS"
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: handleClose,
        }}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: handleSubmit,
        }}
        handleClose={handleClose}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate value="alertSetting.DISABLE_EMAILS_CONFIRM" />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
